export interface MailingListRecipient {
  employeeId: string;
}

export interface PopulatedMailingListRecipient extends MailingListRecipient {
  firstName: string;
  lastName: string;
  lsEmailAddress: string;
  subscribed: boolean;
}

export interface PopulatedMailingList {
  id: string;
  recipients: PopulatedMailingListRecipient[];
}

export interface MailingListPayload {
  subscribe?: MailingListRecipient[];
  unsubscribe?: MailingListRecipient[];
}

export enum MailingListType {
  ALL = 'all',
}
